import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Patricia S.',
  location: 'Sevilla',
  pack: 'MegaPack Completo',
  quote: 'Llevaba 4 años sin dormir bien por las mañanas con mi hijo. En 10 días de aplicar el Tomo 3 de Rutinas la mañana pasó de ser una guerra a ser... normal. No me lo podía creer.'
}, {
  name: 'Javier M.',
  location: 'Madrid',
  pack: 'MegaPack 1',
  quote: "El Tomo 1 me cambió la perspectiva completamente. Dejé de ver a mi hijo como un niño 'difícil' y empecé a entender cómo funciona su cerebro. Eso lo cambia todo."
}, {
  name: 'Laura F.',
  location: 'Bilbao',
  pack: 'MegaPack Completo',
  quote: 'Las cartas para el colegio del Bono 2 son oro puro. En 3 días tenía reunión con el orientador y en dos semanas las adaptaciones firmadas. Algo que llevaba meses intentando conseguir.'
}, {
  name: 'Roberto C.',
  location: 'Valencia',
  pack: 'MegaPack 1',
  quote: 'El Tomo 5 de Vínculo me hizo replantearme todo. Me di cuenta de que la distancia con mi hijo la había creado yo sin querer. Ahora tenemos una relación que nunca habíamos tenido.'
}, {
  name: 'Elena P.',
  location: 'Barcelona',
  pack: 'MegaPack Completo',
  quote: 'El Pack 2 sobre ansiedad llegó justo cuando mi hijo empezó a tener miedo de ir al colegio. Seguí los pasos del Tomo 9 y en tres semanas volvió a entrar sin llorar. Increíble.'
}, {
  name: 'Miguel A.',
  location: 'Zaragoza',
  pack: 'MegaPack Completo',
  quote: 'Compramos el sistema completo y fue la mejor decisión del año. Mi hijo me dijo la semana pasada que soy su mejor amigo. Eso no tiene precio.'
}];
export function MoreTestimonials() {
  return <section className="bg-surface-white py-12 px-6" data-id="element-182">
      <div className="max-w-6xl mx-auto" data-id="element-183">
        <div className="text-center mb-8" data-id="element-184">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-2" data-id="element-185">
            ❤️ MÁS PADRES QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-186">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-187">
              <div className="flex gap-1 mb-3" data-id="element-188">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-gold text-gold" data-id="element-189" />)}
              </div>
              <p className="text-primary italic mb-4 flex-grow" data-id="element-190">"{t.quote}"</p>
              <div className="pt-3 border-t border-gray-100" data-id="element-191">
                <p className="font-bold text-primary" data-id="element-192">
                  {t.name}{' '}
                  <span className="text-secondary font-normal" data-id="element-193">
                    📍 {t.location}
                  </span>
                </p>
                <p className="text-xs font-semibold text-gold mt-1 bg-gold/10 inline-block px-2 py-1 rounded" data-id="element-194">
                  {t.pack}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}